import merge from 'lodash-es/merge';
import { TGetColorStateDefinition } from '../types';
import buildColorsObject from './buildColorsObject';

/**
 * Esta función arma un objeto con los colores que se deben aplicar para
 * garantizar que el resultado sea el esperado, por ejemplo, al aplicar un
 * color a un border. Esto es así ya que en ThemeUI hay situaciones en las que
 * si no se aplican el color de borde a cada uno de los lados, no se aplica el
 * color deseado.
 *
 * Ejemplo de lo antedicho es:
 *
 * borderRight: '1px solid',
 * borderColor: 'red'.
 *
 * En este caso, el borde derecho no será rojo como se espera, ya que la
 * propiedad borderRight aplicará un borderRightColor: 'initial', que solamente
 * puede ser reescrito por borderRightColor: 'red'.
 */
export default function getColorsByDefinition(
  definition: Partial<TGetColorStateDefinition>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options?: { mergeObject?: Record<string, any> },
) {
  return merge(
    buildColorsObject({
      ...(definition.color ? { color: definition.color } : null),
      ...(definition.backgroundColor
        ? { backgroundColor: definition.backgroundColor }
        : null),
      ...(definition.borderColor
        ? {
            borderColor: definition.borderColor,
          }
        : null),
    }),
    options?.mergeObject,
  );
}
